import classNames from 'classnames';
import React from 'react';
import { Edit1Icon, PlayIcon } from 'tdesign-icons-react';
import { Button } from 'tdesign-react';

import { ISpineResult } from '../../folder';
import styles from './index.module.less';

interface IProps {
  value: ISpineResult;
  disabled?: boolean;
  removeIcon: JSX.Element;
  openDialog: () => void;
  handleDelete: () => void;
}

// Spine预览和编辑（横向长条形式）
const SpinePreviewAndEdit: React.FC<IProps> = ({
  value,
  disabled = false,
  removeIcon,
  openDialog,
  handleDelete,
}) => (
  <div className={styles.showWrap}>
    <div className={styles.leftItem} onClick={openDialog}>
      <div className={styles.playIcon}>
        <PlayIcon size={16} />
      </div>
      <div className={styles.name}>
        {value?.directoryName}{value?.animation ? `【${value?.animation}】` : ''}
      </div>
    </div>
    <div className={styles.rightItem}>
      <Button
        variant="text"
        icon={<Edit1Icon size={16} />}
        className={classNames(styles.opBtnSmall, {
          ['nova-disabled-opacity']: disabled,
          ['nova-disabled']: disabled,
        })}
        onClick={openDialog}
        disabled={disabled}
      />
      <Button
        variant="text"
        icon={removeIcon}
        className={classNames(styles.opBtnSmall, {
          ['nova-disabled-opacity']: disabled,
          ['nova-disabled']: disabled,
        })}
        disabled={disabled}
        onClick={handleDelete}
      />
    </div>
  </div>
);

export default SpinePreviewAndEdit;
